module.exports = __webpack_public_path__ + "img/icon-like.d38b618f.svg";